import React, { useEffect } from "react";

const Sitemap = () => {
  useEffect(() => {
    const pages = [
      { url: "/", changefreq: "daily", priority: 1.0 },
      {
        url: "/Category/Accessories/Goldia",
        changefreq: "monthly",
        priority: 0.8,
      },
      {
        url: "/Category/Vehicules/Auxbeam",
        changefreq: "weekly",
        priority: 0.9,
      },
      { url: "/Category/Solar/Jackery", changefreq: "yearly", priority: 0.5 },
      {
        url: "/Category/MixedProducts/Overhalfsale",
        changefreq: "yearly",
        priority: 0.7,
      },
      {
        url: "/EarthQuakePage",
        changefreq: "weekly",
        priority: 0.2,
      },
    ];
    const sitemapXml = `<?xml version="1.0" encoding="UTF-8"?>
  <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
    ${pages
      .map(
        (page) => `
      <url>
        <loc>${window.location.origin}${page.url}</loc>
        <changefreq>${page.changefreq}</changefreq>
        <priority>${page.priority}</priority>
      </url>
    `
      )
      .join("")}
  </urlset>`;

    const blob = new Blob([sitemapXml], { type: "application/xml" });
    const url = URL.createObjectURL(blob);

    // Force file download
    const link = document.createElement("a");
    link.href = url;
    link.download = "sitemap.xml";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }, []);

  return <p>Generating sitemap...</p>; // Display a message
};

export default Sitemap;
